import { $api } from "../generated/client";

/** Backfill isCancelled=true in statisticsReturnRequestFlattened. Idempotent. Pass shopId to scope to one shop. */
export function useSyncCancelledReturnRequestsStats() {
  return $api.useMutation(
    "post",
    "/super-admin/statistics/sync-cancelled-return-requests",
  );
}
